import successIcon from './assets/static/success-icon.png';
import { Container, SuccessIcon, Text } from './styles';

type ToastAuthProps = {
    title: string;
};

const ToastAuth = ({ title }: ToastAuthProps) => (
    <Container>
        <SuccessIcon src={successIcon} />
        <Text>{title}</Text>
    </Container>
);

export default ToastAuth;
